import { useEffect } from "react";

const POLARIS_BACKDROP_CLASS = "Polaris-Backdrop";

/*
 * Prevents a Polaris <Modal> from closing when the backdrop (area outside
 * the dialog) is clicked. Polaris wires the same onClose callback to the
 * backdrop click, the header "X" button, and Escape, with no prop to opt
 * out of just the backdrop click. This hook intercepts the click in the
 * capture phase, before Polaris' own backdrop onClick runs, and stops it.
 *
 * Example: useBlockModalBackdropClose(isModalOpen) — clicking outside the
 * dialog no longer dismisses it, but the "X" button and Escape still do.
 */
const useBlockModalBackdropClose = (isActive) => {
  useEffect(() => {
    if (!isActive) return undefined;

    const blockBackdropClick = (event) => {
      if (event.target?.classList?.contains(POLARIS_BACKDROP_CLASS)) {
        event.stopPropagation();
      }
    };

    document.addEventListener("click", blockBackdropClick, true);
    return () => document.removeEventListener("click", blockBackdropClick, true);
  }, [isActive]);
};

export default useBlockModalBackdropClose;
